import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import MarkdownRenderer from 'Components/MarkdownRenderer';
import './AINotification.scss';

/**
 * Custom AI chat toast notification.
 * Rendered via ReactDOM.createPortal into document.body so it escapes the
 * .app-container stacking context (position:fixed) and always appears on top.
 */
const AINotification = ({ title, message, duration = 10000, onClick, onClose }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    if (duration > 0) {
      timerRef.current = setTimeout(() => onClose?.(), duration);
    }
    return () => clearTimeout(timerRef.current);
  }, [duration, onClose]);

  const handleClick = () => {
    clearTimeout(timerRef.current);
    onClick?.();
    onClose?.();
  };

  const content = (
    <div className="ai-notification-container">
      <div
        className="notification notification-success ai-notification-enter"
        onClick={handleClick}
        role="alert"
        aria-live="polite"
      >
        <div className="notification-message">
          {title && <h4 className="title">{title}</h4>}
          <div className="message">
            <MarkdownRenderer className="ai-notification-markdown">{message}</MarkdownRenderer>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default AINotification;

